import type { Router } from "vue-router";
import { allowUnload } from "@/utils/pageUnload";

// In Release (hashed chunk names), a tab left open across a deploy requests page chunks the new
// build no longer has, or a page stylesheet Vite fails to preload. Reload once into the target
// route to pick up the new build; the sessionStorage flag stops a reload loop if the chunk is
// genuinely unavailable. Here rather than inline in the router so it can be tested without
// importing the whole route table.
export const CHUNK_RELOAD_FLAG = "chunkReloadAttempted";

const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;

export function installChunkLoadRecovery(router: Router): void {
  router.onError((error, to) => {
    if (!CHUNK_LOAD_ERROR.test(error?.message ?? "") || sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
      return;
    }
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, "1");
    allowUnload();
    window.location.assign(router.resolve(to.fullPath).href);
  });

  router.afterEach((_to, _from, failure) => {
    if (!failure) {
      sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
    }
  });
}
